export const getFilter = filter => state => state.filters[filter]
